import { useEffect, useState } from "react";
import { ProcedureCardsGrid, DocumentCardsList } from "./documentcards";
import DocumentHeader from "./documentHeader";
import TabsComponent from "../tabswitches";
import dayjs from "dayjs";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ProcedureDocument from "./ProcedureDocument";
import { CircularProgress } from "@mui/material";
import api from "../../../../api/api";
import DropdownPill from "./DropdownPill";
import { useSelector } from "react-redux";
import { DocumentAllCards } from "./documentAllCards";
import PaginationDropdownPill from "./PaginationDropdownPill";
import openEmrinstance from "../../../../api/emrapiInstance";
import Base64ViewerModal from "./base64modal";
import ViewDoc from "../forms/htmls/homesleep";
import ViewPhq9 from "../forms/htmls/phq9";
import ViewMdq from "../forms/htmls/mdq";
import ViewAsrs from "../forms/htmls/asrsform";
import ViewMmse from "../forms/htmls/mmse";
import ViewStopBang from "../forms/htmls/stopbang";
import OnBoardView from "../../../../onboarding/OnBoardView";

const formatDate = (dateString) => dayjs(dateString).format("YYYY-MM-DD");

const Document = ({ searchdate, dataId }) => {
  const [view, setView] = useState(1);
  const [selectedTab, setSelectedTab] = useState(0);
  const [procedureData, setProcedureData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isProcedureDocumentOpen, setIsProcedureDocumentOpen] = useState(false);
  const [searchDate, setSearchDate] = useState(formatDate(searchdate));
  const [selectedProcedure, setSelectedProcedure] = useState({});
  const [encounterData, setEncounterData] = useState([]);
  const [subview, setSubView] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedData, setSelectedData] = useState({});
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedview, setSelectedView] = useState({});
  const [ismodal, setIsModal] = useState(false);
  const [openBase64Viewer, setOpenBase64Viewer] = useState(false);
  const [htmlModal, setHtmlModal] = useState(false);
  const userConfig = useSelector((state) => state.userconfig);
  const patientId = dataId.patientid;
  const practiseid = window.getPracticeId();
  const apikey = process.env.REACT_APP_OPENEMR_KEY;
  const CLINICAL_CATEGORY_IDS = [32, 33, 2, 13];
  const categoryId = view === 2 ? 33 : view === 1 ? 32 : view === 4 ? 2 : 13;
  const fetchOpenEmrDocs = async (categoryIds = []) => {
    const responses = await Promise.all(
      categoryIds.map((catId) =>
        openEmrinstance.post(`documents/get/`, {
          apikey,
          category_id: catId,
          patientid: patientId,
        }),
      ),
    );

    return responses.flatMap((res) =>
      (res.data || []).map((doc) => ({
        ...doc,
        normalizedDate: dayjs(doc.docdate, "YYYY-MM-DD"),
        createddate: dayjs(doc.docdate, "YYYY-MM-DD"),
        documentclass: "Emr",
        source: "openemr",
      })),
    );
  };
  const fetchFormsData = async () => {
    setIsLoading(true);
    try {
      const res = await api.get(
        `/v1/${practiseid}/pcard/${patientId}/formHistory`,
      );

      const forms = Array.isArray(res.data)
        ? res.data.map((item) => ({
            id: item.id,
            title: item.form_name,
            form_name: item.form_name,
            form_id: item.form_id,
            recordid: item.id,

            createddate: dayjs(item.created_at),
            normalizedDate: dayjs(item.created_at),

            documentclass: "Form",
            source: "form",

            html_url: item.html_url,
            pdf_url: item.pdf_url,
          }))
        : [];

      // 🔥 always latest first
      setProcedureData(
        forms.sort(
          (a, b) =>
            dayjs(b.createddate).valueOf() - dayjs(a.createddate).valueOf(),
        ),
      );
    } catch (err) {
      console.error("Error fetching forms data", err);
      setProcedureData([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchAllData = async () => {
      setIsLoading(true);
      try {
        const formsRes = await api.get(
          `/v1/${practiseid}/pcard/${patientId}/formHistory`,
        );
        const formsDocs = Array.isArray(formsRes.data)
          ? formsRes.data.map((item) => ({
              id: item.id,
              title: item.form_name,
              form_name: item.form_name,
              form_id: item.form_id,
              recordid: item.id,

              // 🔑 REQUIRED FIELDS
              createddate: dayjs(item.created_at),
              normalizedDate: dayjs(item.created_at),

              // 👇 identify as form
              documentclass: "Form",
              source: "form",

              // 👇 needed for view
              html_url: item.html_url,
              pdf_url: item.pdf_url,
            }))
          : [];
        const [
          procedureRes,
          encounterRes,
          clinicalRes,
          emrDocsRes,
          onboardingResponse,
        ] = await Promise.all([
          api.post(`/v1/${practiseid}/patient/${patientId}/procedures/get`, {
            category: "Procedures",
            department_id: userConfig.config.departmentid,
          }),
          api.post(`/v1/${practiseid}/patient/${patientId}/procedures/get`, {
            category: "ProgressNotes",
            department_id: userConfig.config.departmentid,
          }),
          api.post(`v1/${practiseid}/clinical-documents`, {
            patient_id: patientId,
            department_id: userConfig.config.departmentid,
          }),
          Promise.all(
            CLINICAL_CATEGORY_IDS.map((catId) =>
              openEmrinstance.post(`documents/get/`, {
                apikey,
                category_id: catId,
                patientid: patientId,
              }),
            ),
          ),
          api.get(`/v1/${practiseid}/onboarding/get_all_patients`),
        ]);
        // ----------- ONBOARDING LOGIC -----------
        const onboardingData =
          onboardingResponse?.status === 200
            ? onboardingResponse.data || []
            : [];

        const filteredOnboarding = onboardingData.filter(
          (item) => item?.patientid == patientId,
        );
        console.log(filteredOnboarding, "onboard");
        const normalizedOnboarding = filteredOnboarding.map((item) => ({
          ...item,

          exam: item?.fullname || "Patient Onboarding",
          document_data: "Onboarding Form",

          docdate: dayjs(item.created_at, "YYYY-MM-DD"),
          normalizedDate: dayjs(item.created_at, "YYYY-MM-DD HH:mm:ss"),
          createddate: dayjs(item.created_at, "YYYY-MM-DD HH:mm:ss"),

          documentclass: "Onboarding",
          source: "onboarding",
        }));
        const imagingData =
          procedureRes.data.imagingresults?.map((item) => ({
            ...item,
            normalizedDate: dayjs(item.createddate),
            createddate: dayjs(item.createddate),
            source: "imaging",
          })) || [];

        const encounterDocs =
          encounterRes.data.encounterdocuments?.map((item) => ({
            ...item,
            normalizedDate: dayjs(item.createddate),
            createddate: dayjs(item.createddate),
            source: "encounter",
          })) || [];

        const clinicalDocs =
          clinicalRes.data.clinicaldocuments?.map((item) => ({
            ...item,
            normalizedDate: dayjs(item.createddate),
            createddate: dayjs(item.createddate),
            source: "clinical",
          })) || [];

        const emrDocs = emrDocsRes.flatMap((res) =>
          (res.data || []).map((doc) => ({
            ...doc,
            normalizedDate: dayjs(doc.docdate, "YYYY-MM-DD"),
            createddate: dayjs(doc.docdate, "YYYY-MM-DD"),
            documentclass: "Emr",
            source: "openemr",
          })),
        );

        const merged = [
          ...normalizedOnboarding,
          ...imagingData,
          ...encounterDocs,
          ...clinicalDocs,
          ...emrDocs,
          ...formsDocs,
        ];
        console.log(emrDocs, "merged");
        setProcedureData(merged);
      } catch (error) {
        console.error("Error fetching all data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    // const fetchClinicalDocuments = async () => {
    //   setIsLoading(true);
    //   try {
    //     const response = await api.post(`v1/${practiseid}/clinical-documents`, {
    //       patient_id: patientId,
    //       department_id: userConfig.config.departmentid,
    //     });
    //     if (response.status === 200) {
    //       setProcedureData(response.data.clinicaldocuments || []);
    //     }
    //   } catch (error) {
    //     console.error("Error fetching clinical documents:", error);
    //   } finally {
    //     setIsLoading(false);
    //   }
    // };
    const fetchClinicalDocuments = async () => {
      setIsLoading(true);
      try {
        const [clinicalRes, emrDocs] = await Promise.all([
          api.post(`v1/${practiseid}/clinical-documents`, {
            patient_id: patientId,
            department_id: userConfig.config.departmentid,
          }),
          fetchOpenEmrDocs([13]), // 👈 Clinical
        ]);

        const clinicalDocs =
          clinicalRes.data.clinicaldocuments?.map((item) => ({
            ...item,
            normalizedDate: dayjs(item.createddate),
            createddate: dayjs(item.createddate),
            source: "clinical",
          })) || [];

        setProcedureData([...clinicalDocs, ...emrDocs]);
      } catch (error) {
        console.error("Error fetching clinical documents:", error);
      } finally {
        setIsLoading(false);
      }
    };

    // const fetchProcedureData = async () => {
    //   setIsLoading(true);
    //   try {
    //     const payload = {
    //       category: subview === 1 ? "Procedures" : "ProgressNotes",
    //       department_id: userConfig.config.departmentid,
    //     };
    //     const response = await api.post(
    //       `/v1/${practiseid}/patient/${patientId}/procedures/get`,
    //       payload
    //     );

    //     if (response.status === 200) {
    //       subview === 1
    //         ? setProcedureData(response.data.imagingresults || [])
    //         : setProcedureData(response.data.encounterdocuments || []);
    //     }
    //   } catch (error) {
    //     console.error("Error fetching procedure data:", error);
    //   } finally {
    //     setIsLoading(false);
    //   }
    // };
    const fetchProcedureData = async () => {
      setIsLoading(true);
      try {
        const payload = {
          category: subview === 1 ? "Procedures" : "ProgressNotes",
          department_id: userConfig.config.departmentid,
        };

        const response = await api.post(
          `/v1/${practiseid}/patient/${patientId}/procedures/get`,
          payload,
        );

        const apiDocs =
          subview === 1
            ? response.data.imagingresults || []
            : response.data.encounterdocuments || [];

        const normalizedApiDocs = apiDocs.map((item) => ({
          ...item,
          normalizedDate: dayjs(item.createddate),
          createddate: dayjs(item.createddate),
          source: subview === 1 ? "imaging" : "encounter",
        }));
        console.log(subview, "subview");
        // 👇 OpenEMR integration
        const emrDocs = await fetchOpenEmrDocs([subview == 1 ? 32 : 33]);

        setProcedureData([...normalizedApiDocs, ...emrDocs]);
      } catch (error) {
        console.error("Error fetching procedure data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (subview === 0) {
      // All
      fetchAllData();
    } else if (subview === 3) {
      // Clinical
      fetchClinicalDocuments();
    } else if (subview === 4) {
      fetchFormsData();
    } else {
      // Imaging (1) or Encounter (2)
      fetchProcedureData();
    }
  }, [searchdate, subview]);

  // Extract unique years
  const uniqueYears = Array.from(
    new Set(procedureData.map((item) => dayjs(item.createddate).year())),
  ).sort((a, b) => b - a);
  const tabs = [
    { label: "All", width: 64 },
    ...uniqueYears.map((year) => ({
      label: year.toString(),
      width: 64,
    })),
  ];

  if (uniqueYears.length > 2) {
    tabs.push({ label: "Archive", width: 64 });
  }

  useEffect(() => {
    if (selectedTab >= tabs.length) setSelectedTab(0);
  }, [tabs.length, selectedTab]);

  const dropdownOptions = tabs.map((t, i) => ({ label: t.label, value: i }));
  const sortByLatest = (data = []) =>
    [...data].sort(
      (a, b) => dayjs(b.createddate).valueOf() - dayjs(a.createddate).valueOf(),
    );

  const filteredData = () => {
    const selectedLabel = tabs[selectedTab]?.label;

    // ✅ ALL
    if (selectedLabel === "All") {
      return sortByLatest(procedureData);
    }

    // ✅ ARCHIVE
    if (selectedLabel === "Archive") {
      const maxYear = Math.max(...uniqueYears);
      return sortByLatest(
        procedureData.filter(
          (item) => dayjs(item.createddate).year() < maxYear - 1,
        ),
      );
    }

    // ✅ SPECIFIC YEAR
    const year = parseInt(selectedLabel);
    return sortByLatest(
      procedureData.filter((item) => dayjs(item.createddate).year() === year),
    );
  };

  // Group data by month/day
  const groupedProcedures = () => {
    const grouped = filteredData().reduce((acc, item) => {
      const month = dayjs(item.createddate).format("MMMM YYYY");
      const day = dayjs(item.createddate).format("D");

      if (!acc[month]) acc[month] = {};
      if (!acc[month][day]) acc[month][day] = [];
      acc[month][day].push(item);
      return acc;
    }, {});
    return Object.entries(grouped).map(([month, days]) => ({ month, days }));
  };

  const handleViewToggle = (value) => setView(value);

  // Reset pagination when filters/subview change
  useEffect(() => {
    setCurrentPage(1);
  }, [subview, selectedTab, view]);
  const handleHtml = async (row) => {
    try {
      setIsLoading(true);
      const response = await api.get(
        `/v1/${practiseid}/pcard/${patientId}/formHistory/${row.id}`,
      );
      if (response.status == 200) {
        setSelectedData(response.data || {});
        setHtmlModal(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="flex flex-col justify-center px-3">
      <DocumentHeader
        data={dataId}
        viewStatus={view}
        handleView={handleViewToggle}
        searchdate={searchDate}
        setSearchDate={setSearchDate}
        setsubview={setSubView}
        subview={subview}
        options={dropdownOptions}
        value={selectedTab}
        onChange={setSelectedTab}
      />

      {isLoading ? (
        <div className="flex justify-center w-[100%] mt-40">
          <CircularProgress />
        </div>
      ) : view ? (
        <>
          {(() => {
            const allData = filteredData();
            const totalItems = allData.length;
            const totalPages = Math.max(
              1,
              Math.ceil(totalItems / itemsPerPage),
            );
            const safeCurrentPage = Math.min(currentPage, totalPages);
            const startIndex = (safeCurrentPage - 1) * itemsPerPage;
            const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
            const pageItems = allData.slice(startIndex, endIndex);

            return (
              <>
                <div className="flex flex-col gap-4 overflow-auto max-h-screen p-4 h-[450px]">
                  {pageItems.length > 0 ? (
                    pageItems.map((item, index) =>
                      subview === 0 ? (
                        <DocumentAllCards
                          key={index}
                          procedure={item}
                          handleHtml={handleHtml}
                          subview={subview}
                          patid={dataId?.patientid}
                        />
                      ) : (
                        <DocumentCardsList
                          key={index}
                          procedure={item}
                          handleHtml={handleHtml}
                          subview={subview}
                          patid={dataId?.patientid}
                        />
                      ),
                    )
                  ) : (
                    <div className="text-center text-grey-200">
                      No Data Found
                    </div>
                  )}
                  {/* Pagination Footer */}
                  <div className="flex w-full items-center justify-between px-4 py-2">
                    <div className="text-[12px] text-[#6B7280] font-inter">
                      {totalItems > 0
                        ? `Showing ${startIndex + 1}- ${endIndex} of ${totalItems} entries`
                        : "Showing 0 of 0 entries"}
                    </div>

                    <div className="flex items-center gap-3">
                      <div className="flex items-center gap-2">
                        <span className="text-[#000000] font-inter text-[12px]">
                          per page
                        </span>
                        <PaginationDropdownPill
                          options={[
                            { label: "5", value: 5 },
                            { label: "10", value: 10 },
                            { label: "25", value: 25 },
                          ]}
                          value={itemsPerPage}
                          onChange={(val) => {
                            setItemsPerPage(Number(val));
                            setCurrentPage(1);
                          }}
                        />
                      </div>
                      <div className="flex items-center gap-2">
                        <button
                          className={`px-3 py-1 text-[13px] font-inter rounded-md border ${
                            safeCurrentPage === 1
                              ? "text-gray-400 border-[#E5E7EB] cursor-not-allowed"
                              : "text-[#000000]  border-gray-300 hover:bg-[#FFF]"
                          }`}
                          onClick={() =>
                            safeCurrentPage > 1 &&
                            setCurrentPage(safeCurrentPage - 1)
                          }
                          disabled={safeCurrentPage === 1}
                        >
                          Previous
                        </button>
                        <div className="px-[10px] py-1 rounded-lg bg-[#1D2951] text-white">
                          {safeCurrentPage}
                        </div>
                        <button
                          className={`px-3 py-1 text-[13px] font-inter rounded-md border ${
                            safeCurrentPage === totalPages
                              ? "text-gray-400 border-gray-200 cursor-not-allowed"
                              : "text-[#000000]   border-gray-300 hover:bg-[#FFF]"
                          }`}
                          onClick={() =>
                            safeCurrentPage < totalPages &&
                            setCurrentPage(safeCurrentPage + 1)
                          }
                          disabled={safeCurrentPage === totalPages}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })()}
        </>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-2 h-[450px] overflow-y-auto">
          {groupedProcedures().length > 0 ? (
            groupedProcedures().map(({ month, days }, monthIndex) => (
              <div
                key={monthIndex}
                className="w-[100%] h-[312px] mt-3 flex flex-col items-start justify-start p-2 bg-white rounded-[15px] shadow-md border-t-2 border-[#1d2951]"
              >
                <div className="flex items-center mb-2 mx-1.5">
                  <span className="ml-2 font-bold text-[#1d2951] text-base">
                    {month}
                  </span>
                </div>

                <div
                  className="w-[100%] overflow-y-auto h-[200px] pt-6 flex flex-col justify-start"
                  style={{ scrollbarWidth: "none" }}
                >
                  <ul className="w-[100%] space-y-2">
                    {Object.entries(days)
                      .flatMap(([day, items]) =>
                        items.map((item, idx) => ({
                          item,
                          idx,
                          day,
                          fullDate: dayjs(item.createddate).format(
                            "MMMM D, YYYY",
                          ),
                        })),
                      )
                      .sort(
                        (a, b) =>
                          new Date(b.item.createddate) -
                          new Date(a.item.createddate),
                      )
                      .map(({ item, idx, day, fullDate }) => (
                        <div
                          key={`${day}-${idx}`}
                          className="flex flex-col justify-between items-center px-2"
                        >
                          <div className="flex w-full justify-between">
                            <div className="font-normal text-[#1D2951] text-[13px]">
                              {fullDate}
                            </div>
                            <div
                              onClick={(e) => {
                                e.preventDefault();
                                if (item?.imgbasefile) {
                                  setSelectedProcedure(item);
                                  setOpenBase64Viewer(true);
                                  return;
                                } else if (
                                  item.documentclass === "Onboarding"
                                ) {
                                  setSelectedView(item);
                                  setIsModal(true);
                                  return;
                                } else if (item.documentclass === "Form") {
                                  handleHtml(item);
                                  return;
                                }
                                setSelectedProcedure(item);
                                setIsProcedureDocumentOpen(true);
                              }}
                              className="flex gap-2 font-light text-[#1d2951] text-[13px] cursor-pointer"
                            >
                              <RemoveRedEyeIcon
                                style={{ width: "30px", height: "20px" }}
                              />
                              View Document
                            </div>
                          </div>
                          <div className="w-full h-[1px] bg-gray-300 my-1" />
                        </div>
                      ))}
                  </ul>
                </div>
              </div>
            ))
          ) : (
            <div className="text-grey-200 w-[100%] items-center">
              No Data Found
            </div>
          )}
        </div>
      )}
      <Base64ViewerModal
        open={openBase64Viewer}
        onClose={() => setOpenBase64Viewer(false)}
        base64={selectedProcedure?.imgbasefile}
      />
      <ProcedureDocument
        subview={subview}
        isProcedureDocumentOpen={isProcedureDocumentOpen}
        setIsProcedureDocumentOpen={setIsProcedureDocumentOpen}
        procedure={selectedProcedure}
      />

      <OnBoardView
        ismodal={ismodal}
        setIsModal={setIsModal}
        data={selectedview}
      />
      {selectedData?.form_name === "Home Sleep Questionnaire" ? (
        <ViewDoc
          data={selectedData}
          ismodalopen={htmlModal}
          setHtmlModal={setHtmlModal}
        />
      ) : (
        <></>
      )}
      {selectedData?.form_name ===
      "The Patient Health Questionnaire (PHQ-9)" ? (
        <ViewPhq9
          data={selectedData}
          ismodalopen={htmlModal}
          setHtmlModal={setHtmlModal}
        />
      ) : (
        <></>
      )}
      {selectedData?.form_name === "Mood Disorder Questionnaire (MDQ)" ? (
        <ViewMdq
          data={selectedData}
          ismodalopen={htmlModal}
          setHtmlModal={setHtmlModal}
        />
      ) : (
        <></>
      )}
      {selectedData?.form_name ===
      "Adult ADHD Self Report Scale (ASRS-vI.I) Symptom Checklist" ? (
        <ViewAsrs
          data={selectedData}
          ismodalopen={htmlModal}
          setHtmlModal={setHtmlModal}
        />
      ) : (
        <></>
      )}
      {selectedData?.form_name === "Mini-Mental State Examination (MMSE)" ? (
        <ViewMmse
          data={selectedData}
          ismodalopen={htmlModal}
          setHtmlModal={setHtmlModal}
        />
      ) : (
        <></>
      )}
      {selectedData?.form_name === "STOP-BANG Sleep Apnea Questionnaire" ? (
        <ViewStopBang
          data={selectedData}
          ismodalopen={htmlModal}
          setHtmlModal={setHtmlModal}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default Document;
